/* Copyright 2013 - 2024 Waiterio LLC */

// Vite's compile-time replacement for webpack's `import.meta.webpackContext`.
//
// `tagliatelle/getRoutes.jsx` calls `context(key)` for every key during the
// first render — on the client and inside the static-generate bundle alike —
// so the glob has to be eager. A lazy glob hands `getRoutes` an import
// *function* instead of the module, `module.path` is then undefined, and
// every route silently disappears into the "missing export path" branch.
//
// The negative pattern reproduces webpack's `(?!.*\.test\.(js|jsx)$)`
// lookahead: every file under `pages/__tests__` ends in `.test.jsx`, so both
// spellings select exactly the same modules.
const modules = import.meta.glob(
  ['./pages/**/*.{js,jsx}', '!./pages/**/*.test.{js,jsx}'],
  { eager: true },
)

const pagesPrefix = './pages/'

// webpack keyed its context on paths relative to the `./pages` root it was
// given (`./HomeRedirect.jsx`), while `import.meta.glob` keys on paths
// relative to this file (`./pages/HomeRedirect.jsx`). Strip the prefix so the
// keys — which `getRoutes` matches with `key.endsWith('page')` when reporting
// a page that forgot to export `path` — keep naming the page rather than its
// directory.
const keys = Object.keys(modules).map(
  key => `./${key.slice(pagesPrefix.length)}`,
)

const context = key => modules[key.replace(/^\.\//, pagesPrefix)]

context.keys = () => keys

export default context
